<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  // SZ: contador na sidebar (Figma)
  count: {
    type: Number,
    default: 0,
  },
  // SZ: estado combinado de desconexão (reauthorization_required do Chatwoot
  // OU detecção custom evogo2). Vindo do Sidebar.vue via SidebarGroupLeaf.
  disconnected: {
    type: Boolean,
    default: false,
  },
});

const showDisconnectedIcon = computed(() => {
  return props.disconnected || props.inbox.reauthorization_required;
});
</script>

<template>
  <span
    class="size-5 grid place-content-center rounded-full bg-n-alpha-2"
    :class="{ 'bg-n-solid-blue': active }"
  >
    <ChannelIcon :inbox="inbox" class="size-3" />
  </span>
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <span
    v-if="count > 0"
    class="sz-side-count"
    :class="{ 'sz-side-count--active': active }"
  >{{ count }}</span>
  <svg
    v-if="showDisconnectedIcon"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    xmlns="http://www.w3.org/2000/svg"
    class="size-5 flex-shrink-0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M12 20h.01" />
    <path d="M8.5 16.429a5 5 0 0 1 7 0" />
    <path d="M5 12.859a10 10 0 0 1 5.17-2.69" />
    <path d="M19 12.859a10 10 0 0 0-2.007-1.523" />
    <path d="M2 8.82a15 15 0 0 1 4.177-2.643" />
    <path d="M22 8.82a15 15 0 0 0-11.288-3.764" />
    <path d="m2 2 20 20" />
  </svg>
</template>

<style scoped>
.sz-side-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 20px;
  padding: 0 4px;
  background: #ECECEC;
  border-radius: 4px;
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: #525252;
  flex-shrink: 0;
}
.sz-side-count--active {
  background: #C0DDC7;
  color: #236D23;
}
:global(.dark) .sz-side-count {
  background: #2A2D31;
  color: #B8BBC1;
}
:global(.dark) .sz-side-count--active {
  background: #1F3A24;
  color: #7DBA80;
}
</style>
